import log from './log';
export default function pushOptimizelyEvent(eventName, module, additionalTags) {
    log.debug('Pushing optimizely event: ', eventName, module ? module : '', additionalTags ? additionalTags : '');
    window['optimizely'] = window['optimizely'] || [];
    if (typeof window['optimizely'].push !== 'function') {
        return;
    }
    window['optimizely'].push({
        type: 'event',
        eventName,
        tags: Object.assign({ revenue: 0, value: 0.0 }, additionalTags),
    });
}
